import React from 'react';

interface CmsFile {
  url: string;
  description: string;
}

interface ShoppingLinkItem {
  label: string;
  url: string;
  external?: boolean;
  image: CmsFile | null;
}

interface ShoppingLinkGroup {
  group_icon: CmsFile | null;
  group_title: string;
  items: ShoppingLinkItem[];
}

interface CmsShoppingLinksData {
  name?: string;
  component?: string;
  groups: ShoppingLinkGroup[];
}

interface CmsShoppingLinksProps {
  data: CmsShoppingLinksData;
  className?: string;
}

export const CmsShoppingLinks: React.FC<CmsShoppingLinksProps> = ({ data, className = '' }) => {
  return (
    <div className={`block px-10 py-0 md:px-10 sm:px-4 ${className}`}>
      <div className="flex flex-wrap items-center justify-center gap-6">
        {data.groups.map((group) => (
          <div key={group.group_title} className="flex flex-col">
            <div className="flex items-center justify-center gap-4 pb-4 border-b-2 border-gray-800">
              {group.group_icon && (
                <img
                  src={group.group_icon.url}
                  alt={group.group_icon.description}
                  className="h-8 w-auto"
                />
              )}
              <h2 className="font-extrabold text-2xl leading-7">{group.group_title}</h2>
            </div>
            <div className="flex flex-wrap items-stretch justify-center gap-6 pt-6 md:gap-6 sm:gap-4 sm:pt-4">
              {group.items.map((item) => (
                <div
                  key={item.label}
                  className="border border-gray-300 rounded w-[200px] flex hover:shadow-lg transition-shadow md:w-[200px] sm:w-[105px]"
                >
                  <a
                    href={item.url}
                    target={item.external ? '_blank' : '_self'}
                    rel={item.external ? 'noopener noreferrer' : undefined}
                    className="text-gray-800 no-underline flex flex-1 flex-col"
                  >
                    <div className="flex items-center justify-center">
                      {item.image && (
                        <img
                          src={item.image.url}
                          alt={item.image.description}
                          className="h-[185px] w-auto md:h-[185px] sm:h-[95px]"
                        />
                      )}
                    </div>
                    <div className="flex items-center justify-center">
                      <h2 className="font-bold text-lg leading-[22px] p-4 text-center md:text-lg md:leading-[22px] md:p-4 sm:text-sm sm:leading-[21px] sm:py-4 sm:px-2">
                        {item.label}
                      </h2>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CmsShoppingLinks;
